export default __webpack_public_path__ + "static/media/Loans_WebBanner.418ac4ba.png";